<script lang="ts">
  import Card from "../../Core/Card.svelte";
  import { Col } from "sveltestrap";
  import { chart } from "svelte-apexcharts";
  import { Growth } from "../../../Data/Chart/Dashboard/Default/Chart";
  import { GrowthOverview } from "../../../utils/Constant/Constant";
</script>

<Col xl="6" class="col-50 box-col-6 des-xl-50">
  <Card cardBodyprops="p-0 growth-overview">
    <div slot="customheader" class="header-top d-sm-flex align-items-center">
      <h5>{GrowthOverview}</h5>
      <div class="center-content">
        <p class="d-flex align-items-center">
          <i class="toprightarrow-primary fa fa-arrow-up me-2" />80% Growth
        </p>
      </div>
    </div>
    <div slot="contentbody">
      <div id="chart-dashbord">
        <div use:chart={Growth} />
      </div>
    </div>
  </Card>
</Col>

